import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer = () => {
  const { t } = useLanguage();
  
  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${companyInfo.whatsapp}`, '_blank');
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Sobre */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="/logo.png" 
                alt="JC FLOORS & TILES" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-sm leading-relaxed">
              {t.footer.description}
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.footer.quickLinks}</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm hover:text-amber-500 transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/sobre" className="text-sm hover:text-amber-500 transition-colors">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-sm hover:text-amber-500 transition-colors">
                  {t.nav.services}
                </Link>
              </li>
              <li>
                <Link to="/galeria" className="text-sm hover:text-amber-500 transition-colors">
                  {t.nav.gallery}
                </Link>
              </li>
              <li>
                <Link to="/contato" className="text-sm hover:text-amber-500 transition-colors">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.footer.contactTitle}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <Phone className="w-4 h-4 mt-1 text-amber-500 flex-shrink-0" />
                <span className="text-sm">{companyInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="w-4 h-4 mt-1 text-amber-500 flex-shrink-0" />
                <span className="text-sm">{companyInfo.email}</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 text-amber-500 flex-shrink-0" />
                <div className="text-sm">
                  <div>{companyInfo.address}</div>
                  <div>{companyInfo.locality}</div>
                </div>
              </li>
              <li className="flex items-start space-x-2">
                <Instagram className="w-4 h-4 mt-1 text-amber-500 flex-shrink-0" />
                <a href={companyInfo.instagramUrl} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-amber-500 transition-colors">
                  {companyInfo.instagram}
                </a>
              </li>
            </ul>
          </div>

          {/* Redes Sociais */}
          <div>
            <h3 className="text-white font-semibold mb-4">{t.footer.socialMedia}</h3>
            <p className="text-sm mb-4">{t.footer.socialDesc}</p>
            <div className="flex space-x-3">
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-600 transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href={companyInfo.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-600 transition-colors"
                data-testid="footer-instagram-link"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-amber-600 transition-colors"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm">
            © 2025 {companyInfo.name}. {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};